import * as React from 'react';
import './TermsAndConditions.css';

class TermsAndConditionsComponent extends React.Component {

  render() {

    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-8">
              <h1 className="bold-title">
                Términos y condiciones
              </h1>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-12 col-md-4">
              <p className="breadcrumb text-right">
                Inicio > Términos y condiciones
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <p className="lead text-center">
                Bienvenido a <strong>www.thecrowdangel.com</strong>
              </p>
              <p className="text-center">
                A continuación, le exponemos los términos y condiciones de acceso, uso y funcionamiento del presente
                sitio web (en lo sucesivo, el <strong>“sitio o sitio web”</strong>).
              </p>
            </div>
          </div>
          <h4 className="featured c-primary">
            A. Uso del sitio web
          </h4>
          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  1.-
                </span>
                Datos identificativos.
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Los términos y condiciones que más adelante se indican regulan el acceso y uso del sitio web&nbsp;
                <a href="https://thecrowdangel.com" title="The Crowd Angel">www.thecrowdangel.com</a>, el cual es
                responsabilidad de <strong>THE CROWD ANGEL P.F.P, S.L.</strong> (en
                adelante, <strong>TCA</strong> o <strong>la Compañía</strong>), con domicilio en Madrid (28010), calle 
                Orfila 10, Bajos Izq, provista de CIF B-65.640.724, con dirección de correo
                electrónico&nbsp;
                <a
                  href="mailto:support@thecrowdangel.com"
                  title="support@thecrowdangel.com"
                >
                  support@thecrowdangel.com
                </a>, e inscrita en el
                Registro Mercantil de Madrid, al tomo 37.049, folio 61, hoja M-661.719, Inscripción 1ª.</p>

              <p>Dentro de la expresión "sitio o sitio web" se comprenden -con carácter enunciativo pero no limitativo-
                los textos, gráficos, imágenes, animaciones, creaciones musicales, vídeos, sonidos, dibujos,
                fotografías, etc. incluidos en el mismo, y, en general, todas las creaciones expresadas por cualquier
                medio o soporte, tangible o intangible, actualmente conocido o que se invente en el futuro, con
                independencia de que sean susceptibles o no de propiedad intelectual de acuerdo al Texto Refundido de la
                Ley de Propiedad Intelectual o norma que en un futuro la sucediera.</p>

              <p>El acceso al sitio implica que el visitante adquiere una serie de derechos y obligaciones, con objeto
                de garantizar el adecuado disfrute de los servicios y contenidos que se encuentran en el mismo y que TCA
                pone a disposición gratuitamente del usuario (en lo sucesivo, el <strong>“usuario”</strong>).</p>

              <p>El usuario es consciente que el acceso y utilización de los servicios y contenidos del sitio se realiza
                bajo su única y exclusiva responsabilidad.</p>

              <p>Toda persona física o jurídica que acceda al sitio web tendrá la consideración genérica de usuario. El
                usuario utilizará los servicios y contenidos exclusivamente para fines particulares, con exclusión de
                cualquier modalidad de utilización posterior de los mismos con ánimo de lucro o reporte de algún
                beneficio, directo o indirecto.</p>

              <p>TCA pone en conocimiento del usuario los presentes términos y condiciones generales de uso, que son
                aceptados expresa y plenamente por éstos por el mero hecho de acceder al sitio web y/o a la
                visualización de los contenidos o utilización de los servicios contenidos en el sitio web.</p>

              <p>Si estas condiciones generales fueran sustituidas por otras en todo o en parte, dichas nuevas
                condiciones generales serán remitidas por parte de TCA a cada uno de los usuarios, mediante correo
                electrónico y/o notificación a través de la plataforma, remitido a la dirección de correo electrónico
                facilitada en el proceso de Registro, con requerimiento de aceptación expresa. Sin perjuicio de lo
                anterior, el usuario del sitio web deberá acceder a estas condiciones generales de forma periódica para
                conocer las sucesivas versiones que se incluyan aquí, aunque se recomienda que el usuario acceda a las
                mismas cada vez que pretenda acceder o hacer uso de los servicios y contenidos del sitio web.</p>

              <p>En caso que el usuario no acepte las presentes condiciones generales o, en su caso, las posibles
                condiciones substitutivas de las mismas, el usuario deberá abstenerse de acceder al sitio web.</p>

              <p>El usuario deberá establecer las medidas de seguridad de carácter técnico adecuadas para evitar
                acciones no deseadas en su sistema de información, archivos y equipos informáticos empleados para
                acceder a Internet y, en especial, al sitio web, siendo consciente de que Internet no es totalmente
                seguro.</p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  2.-
                </span>
                Descripción general de contenidos y servicios.
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>El sitio web de TCA ofrece a sus usuarios registrados la posibilidad de acceder a la realización de
                inversiones en empresas que hayan procedido a presentar solicitudes de inversión, en los términos y
                condiciones que quedarán definidos por los contratos que al efecto se firmarán electrónicamente. En los
                distintos apartados del sitio web, el usuario podrá acceder a aquellos servicios para emprendedores de
                apoyo para la estructuración de operaciones de inversión y podrá mostrar interés en operaciones de
                inversión definidas por TCA, comprometer su inversión en las mismas y ejecutarlas, usando la plataforma
                electrónica que al efecto TCA pone a su disposición.</p>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  3.-
                </span>
                Naturaleza de actividades.
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>La actividad de TCA desarrollada mediante el sitio web es la propia de una plataforma de financiación
                participativa, reguladas en el Título V de la Ley 5/2015, de 27 de abril. Por tanto, TCA no ostenta la
                condición de empresa de servicios de inversión, ni de entidad de crédito y no está adherida a ningún
                fondo de garantía de inversiones o fondo de garantía de depósitos.</p>

              <p>Las actividades de TCA y las informaciones ofrecidas a través de sus diversos canales (página web,
                blog, redes sociales, plataforma o cualquier otro medio) no deben entenderse como recomendaciones para
                llevar a cabo inversiones, ni asesoramiento financiero o de cualquier otra naturaleza a tal
                respecto.</p>

              <p>Cada inversor debe formar sus propios juicios independientes y adoptar sus propias decisiones en
                relación con su actividad de inversión en el uso de la plataforma. Es decir, el usuario llevará a cabo
                las comprobaciones, estudios y análisis que considere pertinentes para adoptar la sus propias
                decisiones, de la que no responderá en ningún caso TCA.</p>

              <p>Las operaciones de financiación participativa no son objeto de autorización ni de supervisión por la
                Comisión Nacional del Mercado de Valores ni por el Banco de España, por lo que la información facilitada
                por los promotores de las operaciones no ha sido previamente revisada ni aprobada por las referidas
                entidades.</p>

              <p>El importe máximo de captación de fondos por operaciones de financiación participativa a través de la
                plataforma no podrá ser superior a 2.000.000 de euros, siendo posible la realización de sucesivas rondas
                de financiación que no superen el citado importe en cómputo anual. Cuando las operaciones se dirijan
                exclusivamente a inversores acreditados, el importe máximo anterior podrá alcanzar los 5.000.000 de
                euros.</p>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  4.-
                </span>
                Condiciones de acceso.
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>El acceso al sitio web es libre salvo para aquellos apartados para los que se exija una contraseña de
                acceso. Para que el usuario pueda efectivamente acceder a los apartados reservados, deberá proceder al
                registro previo, a través del formulario de registro disponible en el sitio web, momento en que deberá
                aceptar los presentes términos y condiciones de uso y la política de privacidad.</p>

              <p>Una vez registrado, el usuario dispondrá de un nombre de usuario o "login" y de un "password" o
                contraseña, los cuales conforman la clave de acceso que le permitirá ser identificado como usuario
                registrado y autorizado para acceder a la información confidencial relativa al área privada del sitio
                web. Asimismo, para acceder como usuario deberá identificarse en el apartado habilitado a tal efecto en
                el sitio web con el nombre de usuario y su contraseña.</p>

              <p>El registro por parte del usuario es gratuito, sin perjuicio de la posibilidad de que en un futuro TCA
                pueda repercutir al usuario aquellos gastos o cargos que se deriven como consecuencia de la prestación
                del servicio, los cuales serán debidamente avisados por parte de TCA al usuario.</p>

              <p>TCA se reserva el derecho de incorporar comisiones no pactadas previamente en los términos y
                condiciones. Para ello, deberá comunicarlo a los Usuarios mediante notificación interna en la plataforma
                y/o e-mail con diez días de antelación. En caso de no estar conforme, el usuario podrá notificar a TCA
                la intención de cancelar su cuenta.</p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  5.-
                </span>
                Uso de contraseñas
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Las contraseñas para el acceso a servicios ofrecidos en el presente sitio web, deberán ser guardadas
                por el usuario con la máxima diligencia y responsabilidad, a los efectos de evitar que dicha contraseña
                pudiera caer en manos de un tercero, siendo dichas contraseñas confidenciales a todos los efectos. Por
                tanto, queda terminantemente prohibido el uso de passwords y datos de identificación de terceros, con
                independencia de la forma mediante la que se hayan obtenido dichos datos y contraseñas.</p>

              <p>Si el usuario tuviese alguna sospecha de que sus datos de acceso hubieran podido caer en manos de un
                tercero no autorizado para su uso, lo deberá notificar urgentemente a la Compañía para que ésta pueda
                proceder a su modificación.</p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  6.-
                </span>
                Derechos y obligaciones de Usuario
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>El usuario accederá de forma gratuita y sin necesidad de autorización previa a los contenidos y
                servicios del sitio web disponible, sin perjuicio de la necesidad del previo registro respecto de
                servicios y contenidos específicos destinados a los clientes de TCA, según se determine en las presentes
                condiciones generales de dichos servicios.</p>

              <p>Como usuario del sitio web, éste, además, deberá realizar en todo momento un uso correcto y lícito del
                sitio web y de los servicios que éste incluye o facilita, de conformidad con los presentes términos y
                condiciones generales, la legislación vigente, la moral, las buenas costumbres y el orden público.</p>

              <p>Como consecuencia de lo anterior, el usuario no podrá acceder o utilizar los servicios y contenidos del
                sitio web con fines ilícitos, lesivos de derechos y libertades de terceros, o que puedan perjudicar,
                dañar o impedir por cualquier forma, el acceso a los mismos, en perjuicio de la Compañía, o de
                terceros.</p>

              <p>El usuario no podrá emplear cualquier tipo de virus informático, código, software, programa
                informático, equipo informático o de telecomunicaciones, que puedan provocar daños o alteraciones no
                autorizadas de los contenidos, programas o sistemas accesibles a través de los servicios y contenidos
                prestados en el sitio web o en los sistemas de información, archivos y equipos informáticos de los
                usuarios de los mismos; o el acceso no autorizado a cualesquiera contenidos y/o servicios del sitio
                web.</p>

              <p>Tampoco podrá el usuario introducir información (textos, gráficos, imágenes, vídeos, sonidos, dibujos,
                fotografía, datos, notas, etc.) en el sitio web o emplear los servicios existentes en el mismo con la
                finalidad de atentar directa o indirectamente contra los derechos fundamentales y libertades públicas de
                otros usuarios del sitio web o de TCA, que inciten o promuevan la realización de actos delictivos,
                xenófobos, terroristas o degradantes por razón de edad, sexo, religión o creencias; o de carácter
                pornográfico, obsceno, violento o que atente contra la ley, la moral o las buenas costumbres.</p>

              <p>Igualmente, el usuario se abstendrá de (i) por sí mismo o por terceros, copiar, reproducir, transformar
                y/o distribuir, de manera total o parcialmente, el contenido del sitio web para usos comerciales o
                publicitarios, (ii) publicar, distribuir o divulgar cualquier información a través del sitio web o,
                (iii) transmitir, depositar o descargar por medio del sitio web, archivos de ningún tipo salvo aquellos
                específicamente autorizados por TCA y relacionados con los servicios.</p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  7.-
                </span>
                Derechos y obligaciones de TCA.
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>El deseo de TCA es ofrecer un funcionamiento del sitio web con la mayor disponibilidad y calidad. Por
                ello, TCA llevará a cabo el mantenimiento y la actualización de las herramientas y contenidos del sitio
                web, para lo cual se requerirán intervenciones en la misma que pueden provocar la suspensión temporal de
                su disponibilidad. La política de TCA es la de programar dichos mantenimientos y actualizaciones en
                momentos de reducido tráfico para minimizar los efectos para los usuarios, sin perjuicio de la facultad
                discrecional de TCA para llevarlo a cabo en cualquier momento. No obstante lo anterior, nos reservamos
                el derecho a suspender temporalmente, y sin necesidad de previo aviso a los usuarios, la accesibilidad a
                nuestro sitio web para efectuar operaciones de mantenimiento, reparación, actualización o mejora de los
                servicios, informaciones y contenidos, así como a modificar o actualizar las informaciones, contenidos y
                las condiciones de acceso al mismo.</p>

              <p>Además de lo anterior, TCA se reserva el derecho a limitar, excluir o condicionar el acceso a los
                usuarios cuando no se den todas las garantías de utilización correcta del sitio web de los mismos
                conforme a los presentes términos y condiciones. En consecuencia, y si fuera necesario, TCA podrá exigir
                las responsabilidades que pudieran derivarse por el uso indebido o ilícito de todo o parte de los
                servicios y contenido prestados o incluidos en la en el sitio web, y si fuera necesario, emprender las
                acciones legales o judiciales que resulten pertinentes para la protección tanto de sus derechos propios
                como de terceros que presten sus servicios o contenidos a través del sitio web.</p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  8.-
                </span>
                Exclusión de responsabilidad.
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>TCA queda exenta de cualquier tipo de responsabilidad en los siguientes casos:</p>

              <p>
                <ul>
                  <li>Por la información que se halle fuera del sitio web y que sea accesible mediante enlaces o links
                    localizados en la misma. No obstante, TCA bajo su exclusivo criterio podrá introducir en el sitio
                    web enlaces o links a otras páginas de TCA o de partners de la misma.
                  </li>

                  <li>La inclusión de un determinado enlace o link no implica ni puede ser interpretado como (i) una
                    recomendación o invitación a seguir dicho enlace ni a usar el contenido del sitio web enlazado por
                    medio de ésta ni, en su caso, los servicios ofrecidos por el mismo, con excepción de aquellos
                    vínculos a partners de TCA cuyo acceso sea necesario para el uso mismo de los servicios del sitio
                    web, ni (ii) una recomendación expresa o tácita de inversión (particularmente cuando se incluyan
                    enlaces o links de una empresa que ofrezca al usuario su participación en la financiación de una
                    operación); pero sin que en ningún caso y bajo ninguna circunstancia pueda deducirse que TCA asume
                    responsabilidad alguna respecto de la calidad, fiabilidad, exactitud, corrección, veracidad o
                    legalidad de los contenidos de los sitio web enlazados.
                  </li>

                  <li>Por la imposibilidad o dificultades de conexión a la red de comunicaciones a través de la que
                    resulta accesible este sitio web, independientemente de la clase de conexión utilizada por el
                    usuario.
                  </li>

                  <li>Por la interrupción, suspensión o cancelación del acceso al sitio web, así como por disponibilidad
                    y continuidad del funcionamiento del sitio o de los servicios y/o contenidos en el mismo, cuando
                    ello se deba a una causa ajena al ámbito de control de TCA, ya provenga directa o indirectamente de
                    ésta.
                  </li>

                  <li>Por la calidad y velocidad de acceso al sitio y de las condiciones técnicas que debe reunir el
                    usuario con el fin de poder acceder al sitio y a sus servicios y/o contenidos.
                  </li>

                  <li>Por los retrasos o fallos que se produjeran en el acceso y/o funcionamiento de los servicios y/o
                    contenidos del sitio web, debido a un caso de fuerza mayor. A tales efectos, se entenderá por "caso
                    de fuerza mayor" todas aquellas causas que no hayan podido preverse, o que aún previstas fueran
                    inevitables, y que dan como resultado el incumplimiento de cualesquiera de sus obligaciones.
                  </li>
                </ul>
              </p>
              <div className="gap-20"/>
              <p>El usuario del sitio web responderá personalmente de los daños y perjuicios de cualquier naturaleza
                causados a TCA, directa o indirectamente, por el incumplimiento de cualquiera de las obligaciones
                derivadas de estas condiciones generales u otras normas por las que se rija la utilización del sitio
                web.</p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  9.-
                </span>
                Propiedad Industrial e Intelectual.
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>El usuario conoce que todos los contenidos y servicios ofrecidos a través del sitio web se encuentran
                protegidos por las leyes de propiedad intelectual y que las marcas, nombres comerciales o signos
                distintivos se encuentran protegidos por las leyes vigentes en materia de propiedad industrial y son
                titularidad de TCA.</p>

              <p>El uso del presente sitio web no confiere a los usuarios ningún derecho de explotación de ninguna clase
                ni su titularidad sobre los contenidos de la misma, así como tampoco su propiedad intelectual y/o
                industrial. Los derechos de uso de los usuarios o terceros se limitarán a aquellos expresamente
                reconocidos en los presentes términos y condiciones o reconocidos de forma dinámica durante el uso del
                sitio web por parte del usuario.</p>

              <p>Queda totalmente prohibida la transformación, reproducción, explotación, distribución, comunicación
                pública y/o cesión, ya sea a título oneroso o gratuito, de cualquiera de los contenidos del sitio
                web.</p>

              <p>TCA hace expresa reserva frente a los usuarios y demás terceros del ejercicio de cuantas acciones
                amparen sus legítimos derechos de propiedad intelectual e industrial.</p>

              <p>El uso de la propiedad intelectual de terceros en el contenido del sitio web no debe ser entendido como
                que esa tercera parte otorga su respaldo, apoyo o está de alguna manera asociada con TCA.</p>

              <p>Si la actuación u omisión culpable o negligente directa o indirectamente imputable al usuario del sitio
                web que origine la infracción de los derechos de propiedad intelectual e industrial o de terceros,
                exista o no beneficio para el mismo, originase a TCA daños, pérdidas, obligaciones solidarias, gastos de
                cualquier naturaleza, sanciones, medidas coercitivas, multas y otras cantidades surgidas o derivadas de
                cualquier reclamación, demanda, acción, pleito o procedimiento, sea civil, penal o administrativo, TCA
                tendrá derecho a dirigirse contra el usuario por todos los medios legales a su alcance.</p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  10.-
                </span>
                Solicitud de información.
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Para cualquier duda o sugerencia que pudiera tener en relación con los presentes términos y condiciones
                de uso puede ponerse en contacto con nosotros a través de la siguiente dirección de e-mail:
                <a
                  href="mailto:support@thecrowdangel.com"
                  title="Support"
                >
                  support@thecrowdangel.com
                </a>.
              </p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  11.-
                </span>
                Duración
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>El acceso, los contenidos y servicios ofrecidos a través del sitio web tienen, en principio, una
                duración indefinida. TCA, no obstante, está autorizada para dar por terminado o suspender el acceso, los
                servicios y/o contenidos del mismo en cualquier momento, sin perjuicio de lo que se hubiere dispuesto al
                respecto en los presentes términos y condiciones generales o, en su caso, condiciones particulares que
                regulen el uso de un determinado servicio y/o contenido destinado a los usuarios del sitio web.</p>

              <p>Los usuarios, por su parte, podrán cancelar su cuenta en cualquier momento, siempre que no ostenten
                ninguna vinculación con alguna de las inversiones en curso, poniéndose en contacto con TCA en las
                direcciones de email o por los medios indicados en el sitio web para dicho fin.</p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  12.-
                </span>
                Confidencialidad
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>
                Cualquier información a la que eventualmente tengan acceso los usuarios será considerada confidencial y
                podrá constituir un secreto empresarial de TCA y/o de las sociedades con las que ésta tenga acuerdos.
                Esta información no podrá ser revelada ni comunicada públicamente sin el previo consentimiento escrito
                de TCA, a excepción de aquella que tenga naturaleza manifiestamente pública o devenga de dominio público
                sin incumplimiento de una obligación de confidencialidad frente a TCA.
              </p>
              <div className="gap-20"/>
            </div>
          </div>

          <h4 className="featured c-primary">
            Miscelanea
          </h4>

          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  1.-
                </span>
                Legislación y Jurisdicción aplicable
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Cualquier controversia que pudiera surgir en relación con el presente sitio web se resolverá de acuerdo
                con la legislación española y se someterá, con renuncia expresa al fuero que pudiera corresponder, a los
                Juzgados y Tribunales de la ciudad de Barcelona.</p>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  2.-
                </span>
                Enmiendas
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Los presentes Términos y Condiciones podrán ser objeto de modificación en cualquier momento, y usted
                acepta seguir rigiéndose por ellos, una vez incluidas las modificaciones. Durante un plazo de quince
                (15) días usted podrá comunicarnos su no aceptación de forma expresa, mediante escrito dirigido a la
                dirección que aparece en el apartado 1 de estos términos y condiciones, en cuyo caso usted será dado de
                baja dentro de los cinco (5) días siguientes a la notificación. Cualquier cambio será notificado
                publicando los Términos y Condiciones revisados en este sitio web.</p>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  2.-
                </span>
                Divisibilidad
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Si el todo o alguna parte de estos Términos y Condiciones es nulo, inaplicable o ilegal en una
                jurisdicción, la cláusula en cuestión o, si se permite, la parte relevante de dicha cláusula, será
                invalidada con respecto a esa jurisdicción. El resto de los Términos y Condiciones se mantendrá en
                vigor, y la validez o aplicabilidad de dicha cláusula en cualquier otra jurisdicción no se verá
                afectada. Esta disposición no será efectiva si la divisibilidad afecta la naturaleza básica de los
                Términos y condiciones, o si es contraria a los principios generales del derecho.</p>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  4.-
                </span>
                Notificaciones
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Cualquier notificación que TCA desee realizar a sus usuarios se llevará a cabo generalmente mediante
                correo electrónico y/o notificación a través de la plataforma, remitido a la dirección de correo
                electrónico facilitada en el proceso de Registro, o aquella otra que usted actualice tras el registro
                mediante el correspondiente apartado del sitio web. Es responsabilidad del usuario asegurarse que nos
                comunica cualquier cambio en su dirección de correo electrónico. Se considerará que cualquier
                notificación que le enviemos a su dirección de correo electrónico habrá llegado a su destino en el
                momento del envío.</p>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <h5 className="f-s-18">
                <span className="f-s-24 num">
                  5.-
                </span>
                Terminación
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Estamos en nuestro derecho de dar por concluida su utilización de este sitio web si determinamos, a
                nuestra entera discreción, que usted ha incumplido los Términos y Condiciones.</p>
              <div className="gap-20"/>
            </div>
          </div>

        </div>
      </section>
    );
  }
}

export default TermsAndConditionsComponent;



// WEBPACK FOOTER //
// ./src/modules/terms-and-conditions/TermsAndConditions.component.tsx